import axios from '@/plugins/axios'
import util from '@/services/util'
import constant from '@/services/constants'

import { XLSXWriter } from '@/services/xlsx'

const bookingApiEndPoint = 'admin/booking'

export default {
    namespaced: true,

    state: {
        bookings: [],
        total: 0
    },

    getters: {
        getBookingById: state => id => {
            const booking = state.bookings.find(booking => booking.id === id)

            if (booking) {
                return JSON.parse(JSON.stringify(booking))
            }

            return null
        }
    },

    mutations: {
        setBookings (state, bookings) {
            state.bookings = bookings
        },

        setBookingTotal (state, total) {
            state.total = total
        }
    },

    actions: {
        async fetchBookings ({ commit }, query) {
            if (query?.from && query?.to) {
                const oldDate = new Date(query.to)
                const newDate = new Date(oldDate.setDate(oldDate.getDate() + 1))
                query.to = `${newDate.getFullYear()}-${util.getTwoDigitNumber(newDate.getMonth() + 1)}-${newDate.getDate()}`
            }
            const response = await axios.get(util.buildUrlWithQuery(bookingApiEndPoint, query))
            const { bookings, total } = response
            for (let i = 0; i < bookings.length; i++) {
                bookings[i].createdAt = new Date(bookings[i].createdAt).getTime() + (60 * 420 * 1000)
                bookings[i].visitDate = new Date(bookings[i].visitDate).getTime() + (60 * 420 * 1000)
            }
            commit('setBookings', bookings)
            commit('setBookingTotal', total)
        },

        async getBookingReport ({ state }, query) {
            if (query?.from && query?.to) {
                const oldDate = new Date(query.to)
                const newDate = new Date(oldDate.setDate(oldDate.getDate() + 1))
                query.to = `${newDate.getFullYear()}-${util.getTwoDigitNumber(newDate.getMonth() + 1)}-${newDate.getDate()}`
            }
            const response = await axios.get(util.buildUrlWithQuery(bookingApiEndPoint, query))
            const { bookings } = response
            for (let i = 0; i < bookings.length; i++) {
                bookings[i].bookingDate = new Date(bookings[i].bookingDate).getTime() + (60 * 420 * 1000)
                bookings[i].visitDate = new Date(bookings[i].visitDate).getTime() + (60 * 420 * 1000)
            }
            const writter = new XLSXWriter({
                title: 'Booking',
                subject: 'Report',
                author: state.username
            })

            writter.setHeaders(constant.report.BOOKING_HEADERS)

            bookings.forEach(booking => {
                const bookingRows = [
                    booking.id,
                    util.getDDMMYYYYHHSSDateFormat(booking.createdAt),
                    util.getDDMMYYYYDateFormat(booking.visitDate),
                    `${booking?.user?.name} ${booking?.user?.lastname}`
                ]

                booking.products.forEach(product => {
                    writter.addRow([
                        ...bookingRows,
                        product.ProductID,
                        product.ProductName,
                        product.type,
                        util.getCurrencyFormat(product.price),
                        util.getCurrencyFormat(product.Quantity),
                        util.getCurrencyFormat(product.price * product.Quantity)
                    ])
                })
            })

            util.downloadBlob(
                writter.getXlsxBlob(),
                `AndamandaBooking_${util.getDDMMYYYYDateFormat(new Date())}.xlsx` ?? 'AndamandaBooking.xlsx'
            )
            return writter.getXlsxBlob()
        }
    }
}
